import React from "react";
import { Link } from 'react-router-dom'
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
// import image1 from "assets/img/24092018.png";

class ProductSection extends React.Component {
  state = {
    open: false,
    expanded: null,
  };

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleChange = panel => (event, expanded) => {
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  render() {
    // const { expanded } = this.state;
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer justify="center" style={{ textAlign: "left", color: "black" }}>
            <GridItem xs={12} sm={12} md={8}>
              <Card>
                <CardBody>
                  {/* <center>
                    <img src={image1} alt="Career" style={{ width: 500, height: 250, marginRight: 25 }} />
                  </center> <br /> */}
                  <span style={{ marginBottom: 0 }}><b>December 17, 2018</b></span>
                  <h2 style={{ color: "#4BB64B", marginTop: 0 }}><b>MARKETING</b></h2>
                  <p >We are a growing dynamic consulting firm based in Jakarta that expanding new business lines and territories, looking for exceptional talents with the following traits:
                  </p>
                  <ul>
                    <li>Having strategic, analytic and innovative mindset in order to grab new opportunities</li>
                    <li>Excellent in communicating ideas and concepts</li>
                    <li>Familiar with the concept of inbound marketing which consist of attract, convert, close, and delight the related stakeholders</li>
                    <li>Familiar with social media marketing campaign and be able to develop copywriting materials</li>
                    <li>A self-starter person who able to work under minimum supervision yet a team-player also in terms of coordination.</li>
                  </ul>
                  <p>
                    If you are,
                  </p>
                  <ul>
                    <li>Male/Female</li>
                    <li>Bachelor degree from reputable universities</li>
                    <li>Age max. 27 years old</li>
                    <li>Having a sales / business development experience in training / consulting of ISO product would be an advantage</li>
                    <li>Showing English proficiency and ability in operating Microsoft Office</li>
                  </ul>
                  <p>Please submit your CV / Resume to <Link to="#"><b> hrd@sandtonglobal.com </b> <span style={{ color: "black" }}> with subject: <b>“MARKETING”.</b></span>  </Link></p>
                  <br />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/CareerPage/Sections/ProductSection.3.jsx